/**
 * Individual Disability coverage skeleton
 */

import {
  BaseBenefitPlanPolicyPeriod,
  BenefitDurationTypeEnum,
  RfpInclusionStatusEnum,
} from "@platform/openapi-types";

import {
  BenefitPlanTypeEnum,
  CoverageTypeEnum,
  FundingTypeEnum,
  PlanOptionNameEnum,
  RfpBenefitPlan,
  RfpCoverage,
} from "../../types/rfp.api.types";

export const getIndividualDisabilitySkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.INDIVIDUAL_DISABILITY_INSURANCE,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "individual-disability-plan-1",
      name: "Individual Disability Insurance",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      currentCarrierName: "",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "individualDisability",

        // Benefit Duration
        benefitDuration: {
          type: BenefitDurationTypeEnum.notIncluded,
          amount: 0,
        },

        // Definition of Disability
        definitionOfDisability: undefined,

        // Employer Contribution
        employerContribution: undefined,

        // Pre-Existing Condition
        preExistingCondition: {
          type: "none",
          monthsDiagnosisFreeBeforeEffDate: 0,
          monthsTreatmentFree: 0,
          monthsDiagnosisFreeAfterEffDate: 0,
        },

        // LTD Plan Design
        ltdPlanDesign: {
          type: "notIncluded",
          percent: 0,
          dollarAmount: 0,
        },

        // IDI Plan Design
        idiPlanDesign: {
          type: "notIncluded",
          percent: 0,
          dollarAmount: 0,
        },

        // GSI Benefit Maximum
        gsiBenefitMaximum: 0,

        // Own Occupation Period
        ownOccupationPeriod: {
          type: "notIncluded",
          amount: 0,
        },

        // Elimination Period Days
        eliminationPeriodDays: 0,

        // Mental Illness Benefit
        mentalIllnessBenefit: {
          type: "notIncluded",
          timeframe: 0,
        },

        // Recovery Benefit
        recoveryBenefit: {
          type: "notIncluded",
          amount: 0,
        },

        // Catastrophic Benefit
        catastrophicBenefit: {
          type: "notIncluded",
          amount: 0,
        },

        // Portability
        portability: RfpInclusionStatusEnum.notIncluded,
      },
    } as RfpBenefitPlan,
  ],
});
